/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ClasseMiseAJourMasseSearch
 */
export interface ClasseMiseAJourMasseSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    nomClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    lieucours?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    dateCours?: DateSearch;
    /**
     * 
     * @type {number}
     * @memberof ClasseMiseAJourMasseSearch
     */
    idclasse?: number | null;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    statutLocalisationAgrement?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseMiseAJourMasseSearch
     */
    idconseillerAgrement?: TextSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClasseMiseAJourMasseSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClasseMiseAJourMasseSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClasseMiseAJourMasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClasseMiseAJourMasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseMiseAJourMasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseMiseAJourMasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClasseMiseAJourMasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClasseMiseAJourMasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClasseMiseAJourMasseSearch interface.
 */
export function instanceOfClasseMiseAJourMasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseMiseAJourMasseSearchFromJSON(json: any): ClasseMiseAJourMasseSearch {
    return ClasseMiseAJourMasseSearchFromJSONTyped(json, false);
}

export function ClasseMiseAJourMasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseMiseAJourMasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'nomClasse': !exists(json, 'nomClasse') ? undefined : TextSearchFromJSON(json['nomClasse']),
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'lieucours': !exists(json, 'lieucours') ? undefined : TextSearchFromJSON(json['lieucours']),
        'dateCours': !exists(json, 'dateCours') ? undefined : DateSearchFromJSON(json['dateCours']),
        'idclasse': !exists(json, 'idclasse') ? undefined : json['idclasse'],
        'statutLocalisationAgrement': !exists(json, 'statutLocalisationAgrement') ? undefined : TextSearchFromJSON(json['statutLocalisationAgrement']),
        'idconseillerAgrement': !exists(json, 'idconseillerAgrement') ? undefined : TextSearchFromJSON(json['idconseillerAgrement']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClasseMiseAJourMasseSearchToJSON(value?: ClasseMiseAJourMasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'nomClasse': TextSearchToJSON(value.nomClasse),
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'lieucours': TextSearchToJSON(value.lieucours),
        'dateCours': DateSearchToJSON(value.dateCours),
        'idclasse': value.idclasse,
        'statutLocalisationAgrement': TextSearchToJSON(value.statutLocalisationAgrement),
        'idconseillerAgrement': TextSearchToJSON(value.idconseillerAgrement),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

